<template>
  <q-card class="text-center display-card">
    <q-card-section>
      <template v-if="loading">
        <q-spinner color="primary" size="2.5em" />
      </template>

      <template v-else>
        <div class="text-h5">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div class="text-caption">
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </div>
      </template>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  props: {
    title: [String, Number],
    subtitle: String,
    loading: Boolean
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.display-card {
  color white
  background-color $lm-dark-blue
  border-radius 10px
}
</style>
